import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import { client_state } from "../state/ClientState";
import {
	getCollectionRegistrations,
	isRegisteredOrSubscribed,
	isRegistered,
	getReferenceCounter,
	EntriesRegistrationNode,
} from "../state/registerClientState";
import { SingleTaskManager } from "../TaskManager";
import clientWorkIsDone from "./tasks";
import { iCollection } from "../state/Collection";

export function removeAttribute(attribute: api_cs.Cattributes): void {
	const name = attribute.key.entry;
	attribute.parent.properties.attributes.delete(name);
}

function cleanAttribute(remove: boolean, attribute: api_cs.Cattributes) {
	if (remove) {
		removeAttribute(attribute);
	}
}

export function cleanNode(node: api_cs.Cnode) {
	switch (node.properties.location.state.name) {
		case "local":
			break;
		case "remote":
			for (const attribute of node.properties.attributes.values()) {
				switch (attribute.properties.type.state.name) {
					case "operation": {
						const operation = attribute.properties.type.state.node;
						switch (operation.properties.type.state.name) {
							case "command": {
								const command = operation.properties.type.state.node;
								cleanAttribute(!isRegisteredOrSubscribed(command), attribute);
								break;
							}
							case "action": {
								const action = operation.properties.type.state.node;
								if (getReferenceCounter(action).count <= 0) {
									const name = attribute.key.entry;
									attribute.parent.properties.attributes.delete(name);
								}
								break;
							}
							default:
								unexpectedState(operation.properties.type.state);
						}
						break;
					}
					case "property": {
						const property = attribute.properties.type.state.node;
						switch (property.properties.type.state.name) {
							case "text": {
								const text = property.properties.type.state.node;
								switch (text.properties.is_key.state.name) {
									case "yes":
										break;
									case "no":
										switch (text.properties.is_editable.state.name) {
											case "yes": {
												const $ = text.properties.is_editable.state.node;
												switch ($.properties.modified.state.name) {
													case "yes":
														break;
													case "no":
														cleanAttribute(!isRegisteredOrSubscribed(text), attribute);
														break;
													default:
														unexpectedState($.properties.modified.state);
												}
												break;
											}
											case "no":
												cleanAttribute(!isRegisteredOrSubscribed(text), attribute);
												break;
											default:
												unexpectedState(text.properties.is_editable.state);
										}
										break;
									default:
										unexpectedState(text.properties.is_key.state);
								}
								break;
							}
							case "number": {
								const number = property.properties.type.state.node;
								switch (number.properties.is_editable.state.name) {
									case "yes": {
										const $ = number.properties.is_editable.state.node;
										switch ($.properties.modified.state.name) {
											case "yes":
												break;
											case "no":
												cleanAttribute(!isRegisteredOrSubscribed(number), attribute);
												break;
											default:
												unexpectedState($.properties.modified.state);
										}
										break;
									}
									case "no":
										cleanAttribute(!isRegisteredOrSubscribed(number), attribute);
										break;
									default:
										unexpectedState(number.properties.is_editable.state);
								}
								break;
							}
							case "file": {
								const file = property.properties.type.state.node;
								switch (file.properties.is_editable.state.name) {
									case "yes": {
										const $ = file.properties.is_editable.state.node;
										switch ($.properties.modified.state.name) {
											case "yes":
												break;
											case "no":
												cleanAttribute(!isRegisteredOrSubscribed(file), attribute);
												break;
											default:
												unexpectedState($.properties.modified.state);
										}
										break;
									}
									case "no":
										cleanAttribute(!isRegisteredOrSubscribed(file), attribute);
										break;
									default:
										unexpectedState(file.properties.is_editable.state);
								}
								break;
							}
							case "group": {
								const group = property.properties.type.state.node;
								cleanNode(group.properties.node);
								switch (group.properties.node.properties.modified.state.name) {
									case "yes":
										break;
									case "no":
										cleanAttribute(!isRegisteredOrSubscribed(group), attribute);
										break;
									default:
										unexpectedState(group.properties.node.properties.modified.state);
								}
								break;
							}
							case "state group": {
								const stategroup = property.properties.type.state.node;
								let state_modified = false;
								for (const state of stategroup.properties.states.values()) {
									cleanNode(state.properties.node);
									switch (state.properties.is_selected.state.name) {
										case "yes":
											switch (state.properties.node.properties.modified.state.name) {
												case "no":
													break;
												case "yes":
													state_modified = true;
													break;
												default:
													unexpectedState(state.properties.node.properties.modified.state);
											}
											break;
										case "no":
											break;
										default:
											unexpectedState(state.properties.is_selected.state);
									}
								}
								if (!state_modified) {
									switch (stategroup.properties.is_modified.state.name) {
										case "yes":
											break;
										case "no":
											cleanAttribute(!isRegisteredOrSubscribed(stategroup), attribute);
											break;
										default:
											unexpectedState(stategroup.properties.is_modified.state);
									}
								}
								break;
							}
							case "collection": {
								const collection = property.properties.type.state.node;
								/*TODO edg: This is far too complex. Everyone that has a dependency on the collection
									should add a registration directly on the collection so the garbage collector only has to check that
								*/
								const collection_registrations = getCollectionRegistrations(collection);
								cleanEntriesRegistrationNode(collection_registrations.entries.node);
								const has_entries_registration = isRegisteredOrSubscribed(collection_registrations.entries);
								const has_updates_registration = isRegisteredOrSubscribed(collection_registrations.updates);
								let has_key_registrations = false;
								for (const [key, key_registration] of collection_registrations.keys) {
									if (!isRegisteredOrSubscribed(key_registration)) {
										collection_registrations.keys.delete(key);
									} else {
										has_key_registrations = true;
									}
								}
								let has_registered_entries = false;
								for (const entry of collection.properties.entries.values()) {
									if (isRegistered(entry)) {
										has_registered_entries = true;
									}
								}
								let modified_entries = false;
								for (const entry of collection.properties.entries.values()) {
									switch (entry.properties.location.state.name) {
										case "remote": {
											const remote = entry.properties.location.state.node;
											cleanNode(entry.properties.node);

											if (!isRegistered(entry)) {
												const entry_modified = remote.properties.marked_for_deletion.switch({
													no: () =>
														entry.properties.node.properties.modified.switch({
															no: false,
															yes: true,
														}),
													yes: true,
												});
												if (!has_entries_registration && !entry_modified) {
													iCollection(collection).removeEntry(entry);
												}
												modified_entries = modified_entries || entry_modified;
											}
											break;
										}
										case "local":
											break;
										default:
											unexpectedState(entry.properties.location.state);
									}
								}
								let has_join = false;
								switch (collection.properties.joined.state.name) {
									case "no":
										break;
									case "yes": {
										const join = collection.properties.joined.state.node;
										if (!isRegistered(join)) {
											join.parent.properties.joined.set("no", {});
										} else {
											has_join = true;
										}
										break;
									}
									default:
										unexpectedState(collection.properties.joined.state);
								}
								const is_modified = collection.properties.modified.switch({
									no: false,
									yes: true,
								});
								cleanAttribute(
									!has_entries_registration &&
										!has_updates_registration &&
										!has_key_registrations &&
										!is_modified &&
										!modified_entries &&
										!has_registered_entries &&
										!has_join,
									attribute
								);
								break;
							}
							default:
								unexpectedState(property.properties.type.state);
						}
						break;
					}
					default:
						unexpectedState(attribute.properties.type.state);
				}
			}
			break;
		default:
			unexpectedState(node.properties.location.state);
	}
}

function cleanEntriesRegistrationNode(node: EntriesRegistrationNode): void {
	for (const [name, att] of node) {
		switch (att[0]) {
			case "command":
				if (!isRegisteredOrSubscribed(att[1])) {
					node.delete(name);
				}
				break;
			case "text":
				if (!isRegisteredOrSubscribed(att[1])) {
					node.delete(name);
				}
				break;
			case "number":
				if (!isRegisteredOrSubscribed(att[1])) {
					node.delete(name);
				}
				break;
			case "file":
				if (!isRegisteredOrSubscribed(att[1])) {
					node.delete(name);
				}
				break;
			case "group":
				if (!isRegisteredOrSubscribed(att[1])) {
					node.delete(name);
				} else {
					cleanEntriesRegistrationNode(att[1].node);
				}
				break;
			case "stategroup": {
				const $ = att[1];
				if (!isRegisteredOrSubscribed($)) {
					node.delete(name);
				}
				for (const state_tree of $.states.values()) {
					cleanEntriesRegistrationNode(state_tree);
				}
				break;
			}
			case "collection": {
				const $ = att[1];
				if (!isRegisteredOrSubscribed($.entries) && !isRegisteredOrSubscribed($.updates)) {
					node.delete(name);
				} else {
					cleanEntriesRegistrationNode($.entries.node);
				}
				break;
			}
			default:
				unexpectedState(att[0]);
		}
	}
}

const garbageCollector = new SingleTaskManager(async () => {
	await clientWorkIsDone();
	cleanNode(client_state.properties.root);
}, 100);
export default garbageCollector;
